import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiChevronRight, FiDollarSign, FiClock, FiStar, FiZap } = FiIcons;

const Hero = () => {
  const phoneNumber = "251-522-9131";

  const scrollToForm = () => {
    const element = document.getElementById('get-offer');
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="pt-24 bg-gradient-to-br from-gray-50 to-gray-100 min-h-[90vh] flex items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center space-x-2 bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-bold mb-6">
              <SafeIcon icon={FiStar} className="w-4 h-4" />
              <span>Direct Cash Buyer - No Middlemen</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              I'll Buy Your House for <span className="text-red-600">Top Cash</span> — Any Condition
            </h1>
            
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Skip the stress of listing. I buy houses in any condition, pay all closing costs, and can put cash in your hands in as little as 7 days.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <motion.button
                onClick={scrollToForm}
                className="flex items-center justify-center space-x-3 bg-red-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-700 transition-colors shadow-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <SafeIcon icon={FiZap} className="w-6 h-6 border-2 border-white/20 rounded-full p-1" />
                <span>Get My Cash Offer</span>
                <SafeIcon icon={FiChevronRight} className="w-5 h-5" />
              </motion.button>

              <motion.a
                href={`tel:${phoneNumber}`}
                className="flex items-center justify-center space-x-3 bg-gray-900 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-black transition-colors shadow-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <SafeIcon icon={FiPhone} className="w-6 h-6" />
                <span>Call Tyler Now</span>
              </motion.a>
            </div>

            <div className="flex flex-wrap gap-6 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiDollarSign} className="w-5 h-5 text-red-600" />
                <span>Highest Cash Offers</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-gray-900" />
                <span>Close On Your Timeline</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-2xl shadow-2xl border-4 border-white">
              <img 
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop" 
                alt="House" 
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            <motion.div 
              className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-2xl border-l-8 border-red-600"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            >
              <div className="text-center">
                <div className="text-2xl font-bold text-gray-900">Highest Cash Offer</div>
                <div className="text-red-600 font-extrabold text-xl">GUARANTEED</div>
                <div className="mt-2 text-xs text-gray-500 font-bold">TALK DIRECTLY TO TYLER</div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;